import * as Yup from 'yup';
import { JSX } from 'react';
import { FieldProps } from 'formik';
import { PrimitiveTypes } from '../../shared/interfaces/generics';
import { TemplateFormRenderExpression } from './template-form-render-expression';
import { IdentifierExpression } from '../../expression-evaluator/identifier-expression';
import { LiteralExpression } from '../../expression-evaluator/literal-expression';
import { BinaryExpression } from '../../expression-evaluator/binary-expression';
import { UnaryExpression } from '../../expression-evaluator/unary-expression';
import { TemplateFormFieldValidationType } from './template-form-validation';

export interface TemplateForm<Meta extends object = object> {
  template: TemplateFormGrid[];
  initialValues: TemplateFormState;
  metadata: Meta;
  validationSchema: Yup.ObjectSchema;
}

export interface TemplateFormState {
  name: string;
  [key: string]: unknown;
}

export interface TemplateFormGrid {
  props: {
    isCollapsible?: boolean;
    isCollapsed?: boolean;
    title?: string;
    subTitle?: string;
    renderExpression?:
      | IdentifierExpression
      | LiteralExpression
      | BinaryExpression
      | UnaryExpression
      | null;
  };
  id: string;
  order: number;
  fields: TemplateFormField[];
}

export interface TemplateFormField {
  size: number;
  component: (props: TemplateFormFieldProps) => JSX.Element;
  validationSchema: Yup.ObjectSchema;
  order: number;
  rowBreak?: boolean;
  renderExpression?:
    | IdentifierExpression
    | LiteralExpression
    | BinaryExpression
    | UnaryExpression
    | null;
  props: {
    id: string;
    name: string;
    formMode: TemplateFormMode;
    renderIf?: TemplateFormRenderExpression;
    required?: boolean;
    metadata: object;
    value?: PrimitiveTypes;
  };
}

export type TemplateFormFieldProps = TemplateFormField['props'] &
  FieldProps & {
    entity: string;
    formDisabled: boolean;
  };

export interface TemplateFormFieldValidation {
  type: TemplateFormFieldValidationType;
  value?: string | number | boolean | RegExp;
  errorMessage?: string;
}

export class TemplateFormError extends Error {
  readonly isTemplateError = true;
}

export type TemplateFormMode = 'VIEW' | 'CREATE' | 'EDIT';
